import React, { FC, Children } from 'react';
import { Container } from '@material-ui/core';

const fileNames = [
  { name: 'file A' },
  { name: 'file B' },
  {
    name: 'file C',
    items: [{ name: 'file C-1' }, { name: 'file C-2' }],
  },
  { name: 'file D' },
  {
    name: 'file E',
    items: [
      { name: 'file E-1' },
      { name: 'file E-2' },
      { name: 'file E-3' },
      {
        name: 'file E-4',
        items: [{ name: 'file E-4-1' }, { name: 'file E-4-2' }],
      },
    ],
  },
];

const RecursionComponent: FC<{ items: any; depth: number }> = ({
  items,
  depth,
}) => {
  return (
    <>
      {Children.toArray(
        items.map((item: any) => (
          <>
            <div
              style={{ textAlign: 'left', padding: 4, marginLeft: depth * 20 }}
            >
              - {item.name}
            </div>
            {item.items && (
              <RecursionComponent items={item.items} depth={depth + 1} />
            )}
          </>
        )),
      )}
    </>
  );
};

const Recursion: FC = () => {
  return (
    <Container>
      <RecursionComponent items={fileNames} depth={0} />
    </Container>
  );
};

export default Recursion;
